import { createFileRoute } from "@tanstack/react-router";
import { LabsLabsIndex } from "~/components/labs/LabsExperience";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/labs/labs/")({
  loader: () => null,
  head: () => ({
    meta: seo({
      title: "Labs | C1 Labs",
      description: "Hands-on tutorials, guided walkthroughs, and CTF-style identity-security challenges. Coming soon.",
      url: "/labs/labs",
    }),
    links: seoLinks({ url: "/labs/labs" }),
  }),
  component: LabsLabsIndex,
});
